<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
// import state from "@/store/state.js";
// import indexJs from "@/store/index.js";
// import types from "@/constants/types";
import { mapState } from "vuex";

import { banBackSpace } from "@/constants/banBackSpace.js";

export default {
  name: "App",
  provide() {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  watch: {
  },
  mounted() {
    window.addEventListener("beforeunload", this.saveState);
    this.preventBackSpace();

  },
  created() {
    console.log(`                                         .
                  .JbBQBQBQQ2i
                .PBQBQg2KKQQBQQr
              vQBQP:      .vBQBP.
              rQRgr           MQB1
              dMDL            .B:
          75MQBMB.                7MZ7.
        sBQBQR5hh.              .gQBQBQE.
      .gBQQr                  .5BQBs:IBQBr
      gQgK        r.         uQBQZ.   iQZBr
    JBdd       iRBDu      iQQBgr      rQEQ
    DEQr        rPBQ5   :PBQBL         EDR:
    hQDs          7:   5QBQP          .RbB.
    7QgZ.            rBQBE:           hZQP
      PQQgi         :EBQBr            PMQQ.
      2QBQg7.   :rgQBQS   :dX:.   r2BQBE.
        .IBQBQBQBQBQB5:   rQBQBQBQBQBQgi
          ivKPgPKvi        .v1EPDX2i.
                                              `);
    // 在created钩子中添加路由就绪监听
    this.$nextTick(() => {
      console.log('created - 路由参数:', this.$route.query);
      this.init();// 初始化跳转参数
    });

  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.saveState);
  },
  methods: {
     async init() {
      let token = {
        data: {
          accessToken: sessionStorage.getItem("AccessToken")
        }
      };
      
      // 添加调试信息
      // console.log('window.location.search:', window.location.search);
      // console.log('window.location.hash:', window.location.hash);
      // console.log('this.$route.query:', this.$route.query);
      
      // 尝试从search中解析参数（参数在hash前面的情况）
      let userId, loginType,theme;
      
      // 1. 首先从window.location.search中解析参数
      if (window.location.search) {
        const params = new URLSearchParams(window.location.search);
        userId = params.get('userId');
        loginType = params.get('loginType');
        theme = params.get('theme');
        console.log('从search中解析的参数:', { userId, loginType,theme });
      }
      
      // 2. 如果search中没有，再从hash中解析参数
      if (!userId) {
        const hash = window.location.hash;
        const queryString = hash.split('?')[1];
        if (queryString) {
          const params = new URLSearchParams(queryString);
          userId = params.get('userId');
          loginType = params.get('loginType');
          theme = params.get('theme');
          console.log('从hash中解析的参数:', { userId, loginType,theme });
        }
      }
      
      // 3. 最后尝试从this.$route.query中获取
      if (!userId) {
        userId = this.$route.query.userId;
        loginType = this.$route.query.loginType;
        theme = this.$route.query.theme;
        console.log('从this.$route.query中解析的参数:', { userId, loginType,theme });
      }
      
      if (userId) {
        try {
          token = await this.GetToken({
            loginType: loginType || 0,
            id: userId
          });
          let data = token.data;
          let userInfo = this.$jwt.decode(data.access_token || data.accessToken);
          let userobj = {
            accessToken: data.access_token || data.accessToken,
            id: userInfo.id,
            mobilePhone: userInfo.phone_number,
            realName: userInfo.realName,
            photo: userInfo.photo,
            type: userInfo.userType,
            tenantId: userInfo.tenantId,
            logintype: "oldLogin",
            schoolName: userInfo.schoolName,
            schoolType: userInfo.schoolType,
            isVip: userInfo.isVip //是否是vip
          };
          this.$store.commit("userInfo", userobj);
          this.$router.push("/");
        } catch (error) {
          console.error('获取token失败:', error);
        }
      } else if (!sessionStorage.getItem("AccessToken")) {
        // 已经在登录页面，不需要再跳转
        return;
      }
    },
    // 添加GetToken方法
    GetToken(params) {
      return new Promise((resolve, reject) => {
        this.$Api.GetToken(params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      });
    },
    
    reload() {
      this.isRouterAlive = false;            //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true;         //再打开
      })
    },
    saveState() {
      let { userInfo, tagsList, isToggleTheme } = this.$store.state;
      let simpleState = { userInfo, tagsList, isToggleTheme };
      sessionStorage.setItem("state", JSON.stringify(simpleState));
    },
    //阻止backspace键退出上一层
    preventBackSpace() {
      document.onkeypress = banBackSpace;
      document.onkeydown = banBackSpace;
    },
  },
  computed: {
    ...mapState({
      // userInfo: ["userInfo"],
      // personalDetails: ["personalDetails"]
    }),
    st() {
      return this.$refs.caseContainer.scrollTop;
    }
  },
  watch: {
    '$route.query': {
      handler(val) {
        this.$nextTick(() => {
          if (val && val.key) {
            this.handleZYW(val);
          }
        })
      },
      immediate: true,
      deep: true,
    }
  }
};
</script>
<style>
#app {
  min-height: 100%;
  max-height: 100vh;
  /*max-width: 1920px;*/
  margin: auto;
}

#app>div {
  min-width: 1000px;
}

.el-loading-mask.is-fullscreen {
  display: none !important;
}

body {
  font-size: 16px;
  padding: 0 !important;
}

ul {
  list-style: none;
}

a {
  text-decoration: none;
}

img {
  vertical-align: top;
  border: none;
}

* {
  padding: 0;
  margin: 0;
}

.clearf:after,
.clearf:before {
  content: "";
  display: block;
  clear: both;
}

table {
  margin: 0;
}

div,
p,
span {
  word-wrap: break-word;
}

/* ::-webkit-scrollbar-thumb:horizontal {
  width: 4px;
  background-color: #ccc;
}

::-webkit-scrollbar-track-piece {
  background-color: #fff;
  border-radius: 2px;
  -webkit-border-radius: 2px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
} */

/* ::-webkit-scrollbar-thumb:vertical {
  width: 4px;
  background-color: #cccccc;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #909399;
} */

.qrcode_xhw {
  min-width: 100px !important;
}

::-webkit-scrollbar-track-piece {
  border: 2px solid #f2f2f2;
  background-color: #F2F2F2;
}

::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-radius: 20px;
  border: 1px solid #f2f2f2;
}


/* 定义全局的css变量 */
:root {
  /* 背景色 */
  --theme_bg_color: #fff;
  /* 按钮颜色 */
  /* --theme_button_color: yellowgreen; */
  /* 字体颜色 */
  --theme_font_color: #333333;
  /*父容器背景色 */
  --theme_content_color: #F5FAFE;
  --theme_resizer_border_color: #dadee0;
  --theme_resizer_bg_color: #fff;
  /*边框颜色 */
  --theme_border_color: #F0F0F0;
  /*输入框边框颜色 */
  --theme_inpborder_color: #E7E7E7;

  --theme_compontBg_color: #FBFBFB;
  --theme_table_cell_color: #EBEEF5;
  /*查看代码 弹窗背景色 */
  --theme_code_dialog_bg_color: #fff;
  /*查看代码 输入框背景色 */
  --theme_code_dialog_inp_color: #fff;
  /*顶部 tag字体颜色 */
  --theme_tag_color: #333333;
  /*table边框颜色 */
  --theme_table_border_color: #EBEEF5;

  --theme_table_bg: '#E7E7E7',
}
</style>



// WEBPACK FOOTER //
// src/App.vue